import { useEffect, useState } from "react";
import Pagination from "../../ChannelManagment/ScreenListContent/SubScreenList/Pagination";
import BoxFreeContent from "../ListFreeContent/BoxFreeContent/BoxFreeContent";
import filterItem from "../../../Data/DataFilterFreeContent";
import { contentFreeList } from "../../../Data/Data";

function ListFreeContent({ activeTab }) {

    const [array, setArray] = useState([])

    useEffect(() => {
        setArray(contentFreeList
            .filter(value => {
                if ((activeTab === 0) && (value.type.toLowerCase().includes('علم و تکنولوژی'))) {
                    return value;
                }
                else if ((activeTab === 1) && (value.type.toLowerCase().includes('داستانی'))) {
                    return value;
                }
                else if ((activeTab === 2) && (value.type.toLowerCase().includes('روانشناسی'))) {
                    return value;
                }
                else if ((activeTab === 3) && (value.type.toLowerCase().includes('اقتصاد'))) {
                    return value;
                }
                else if ((activeTab === 4) && (value.type.toLowerCase().includes('مدیریت'))) {
                    return value;
                }
                else if ((activeTab === 5) && (value.type.toLowerCase().includes('اجتماعی'))) {
                    return value;
                }
                else if ((activeTab === 6) && (value.type.toLowerCase().includes('تاریخی'))) {
                    return value;
                }
                else if ((activeTab === 7) && (value.type.toLowerCase().includes('سلامت'))) {
                    return value;
                }
                else if ((activeTab === 8) && (value.type.toLowerCase().includes('فلسفه'))) {
                    return value;
                }
                else if ((activeTab === 9) && (value.type.toLowerCase().includes('موفقیت'))) {
                    return value;
                }
                else if ((activeTab === 10) && (value.type.toLowerCase().includes('زندگی نامه'))) {
                    return value;
                }
            })
            .filter(value => {
                if (filterItem.socialNetwork === "") {
                    return value
                }
                else if (value.socialNetwork.toLowerCase().includes(filterItem.socialNetwork.toLowerCase())) {
                    return value;
                }
            })
            .filter(value => {
                if (filterItem.title === "") {
                    return value
                }
                else if (value.title.toLowerCase().includes(filterItem.title.toLowerCase())) {
                    return value;
                }
            })
            .filter(value => {
                if (filterItem.link === "") {
                    return value
                }
                else if (value.link.toLowerCase().includes(filterItem.link.toLowerCase())) {
                    return value;
                }
            })
            .filter(value => {
                if (filterItem.description === "") {
                    return value
                }
                else if (value.description.toLowerCase().includes(filterItem.description.toLowerCase())) {
                    return value;
                }
            })
        )

    }, [filterItem.socialNetwork, activeTab, filterItem.title, filterItem.link, filterItem.description])

    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage] = useState(3);

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = array.slice(indexOfFirstPost, indexOfLastPost)

    return (
        <div className="absolute top-10 right-10 flex flex-col items-end justify-between w-full h92 overflow-auto custom-scrollbars__content">
            {array.length === 0 ?
                <div className="mr-10">
                    <img src="/image/Dashboard/notFound.png" className="w-40" />
                    <p>متاسفانه موردی یافت نشد</p>
                </div>
                :
                <>
                    <div className="flex flex-col items-end w-full">
                        {currentPosts.map((item, index) => {
                            return (
                                <BoxFreeContent key={index} item={item} />
                            )
                        })}
                    </div>
                    {array.length > 3 ?
                        <Pagination
                            postsPerPage={postsPerPage}
                            totalPosts={array.length}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                        :
                        null}
                </>
            }
        </div>
    )
}
export default ListFreeContent;